module.exports = __webpack_public_path__ + "static/img/yehuo.875e9da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/yehuo.png
// module id = DJMC
// module chunks = 1